import service from '@/store/services/user-service';
import axios from 'axios';

const state = {
    profile: {},
    industryProfile: {},
    report: {},
    market_report: {},
    vestimate_report: {},
    company_report: {},
    loading: false,
    user: {},
    home: "Search",
    activeSection: null,
    user_type: {},
    allow_retail: false,
    user_subscriptions: {},
    user_IBBA2021: false,
    pdfLoading: false,
    pdfLoading2: false,
    csvLoading: false,
    user_subscriptionsData: {},
    cmnText: null,
    totalTeamMembers: null,
    totalActiveTeamMembers: null,
    academic_ip: null,
    userAccess: null,
};

const mutations = {
    SET_PROFILE: (state, payload) => {
        state.profile = payload;
    },

    SET_INDUSTRY_PROFILE: (state, payload) => {
        state.industryProfile = payload;
    },

    SET_CMN_TEXT: (state, payload) => {
        state.cmnText = payload;
    },

    SET_REPORT: (state, payload) => {
        state.report = payload;
    },
    SET_MARKET_REPORT: (state, payload) => {
        state.market_report = payload;
    },
    SET_VESTIMATE_REPORT: (state, payload) => {
        state.vestimate_report = payload;
    },
    SET_COMPANY_REPORT: (state, payload) => {
        state.company_report = payload;
    },

    SET_LOADING: (state, payload) => {
        state.loading = payload;
    },
    SET_USER: (state, payload) => {
        state.user = payload;
    },
    SET_USER_ACCESS: (state, userAccess) => {
        state.userAccess = userAccess;
    },
    SET_HOME: (state, payload) => {
        state.home = payload;
    },
    SET_ACTIVE_SECTION: (state, activeSection) => {
        state.activeSection = activeSection;
    },

    SET_USER_TYPE: (state, user_type) => {
        state.user_type = user_type;
    },
    SET_ALLOW_RETAIL: (state, allow_retail) => {
        state.allow_retail = allow_retail;
    },

    SET_ACADEMIC_IP: (state, academic_ip) => {
        state.academic_ip = academic_ip;
    },

    SET_USER_SUBSCRIPTIONS: (state, user_subscriptions) => {
        state.user_subscriptions = user_subscriptions;
    },
    SET_USER_SUBSCRIPTIONS_DATA: (state, user_subscriptionsData) => {
        state.user_subscriptionsData = user_subscriptionsData;
    },

    SET_USER_IBBA2021: (state, user_IBBA2021) => {
        state.user_IBBA2021 = user_IBBA2021;
    },

    SET_PDF_LOADING: (state, pdfLoading) => {
        state.pdfLoading = pdfLoading;
    },

    SET_PDF_LOADING_2: (state, pdfLoading2) => {
        state.pdfLoading2 = pdfLoading2;
    },

    SET_CSV_LOADING: (state, csvLoading) => {
        state.csvLoading = csvLoading;
    },

    SET_TOTAL_ACTIVE_TEAM_MEMBERS: (state, totalActiveTeamMembers) => {
        state.totalActiveTeamMembers = totalActiveTeamMembers;
    },

    SET_TOTAL_TEAM_MEMBERS: (state, totalTeamMembers) => {
        state.totalTeamMembers = totalTeamMembers;
    },
};

const actions = {
    getProfile({ commit, dispatch, state }, params) {
        let currentSession = localStorage.getItem(
            'vue-authenticate.vueauth_access_token'
        );
        commit('SET_PROFILE', {});

        return service
            .getProfile({
                session_id: currentSession,
                profile_id: params.profile_id,
            })
            .then((res) => {
                if (res.hasOwnProperty('data') && res.data.error) {
                    commit('SET_ERROR_BIT', true, { root: true });
                    commit(
                        'SET_ERROR_INFO',
                        '<br>' +
                        'Server responded with error = True <br> errorCode: ' +
                        res.data.errorCode, { root: true }
                    );
                }
                commit('SET_PROFILE', res);
                return res;
            })
            .catch((err) => {
                commit('SET_ERROR_BIT', true, { root: true });
                commit('SET_ERROR_INFO', err.stack, { root: true });
            });
    },

    getIndustryProfile({ commit, dispatch, state }, params) {
        let currentSession = localStorage.getItem(
            'vue-authenticate.vueauth_access_token'
        );
        commit('SET_INDUSTRY_PROFILE', {});

        return service
            .getIndustryProfile({
                session_id: currentSession,
                profile_id: params.profile_id,
            })
            .then((data) => {
                if (data.hasOwnProperty('data') && data.data.error) {
                    commit('SET_ERROR_BIT', true, { root: true });
                    commit(
                        'SET_ERROR_INFO',
                        '<br>' +
                        'Server responded with error = True <br> errorCode: ' +
                        data.data.errorCode, { root: true }
                    );
                }

                if (data && data.mapImage) {
                    data.data.mapImage = data.mapImage;
                }

                commit('SET_INDUSTRY_PROFILE', data.data);
                commit('SET_CMN_TEXT', data.cmnText);
                return data.data;
            })
            .catch((err) => {
                commit('SET_ERROR_BIT', true, { root: true });
                commit('SET_ERROR_INFO', err.stack, { root: true });
            });
    },

    getReport({ commit, dispatch, state }, params) {
        let currentSession = localStorage.getItem(
            'vue-authenticate.vueauth_access_token'
        );
        commit('SET_LOADING', true);
        commit('SET_REPORT', {});

        return service
            .getReport({
                session_id: currentSession,
                report_id: params.report_id,
            })
            .then((res) => {
                if (res.hasOwnProperty('data') && res.data.error) {
                    commit('SET_ERROR_BIT', true, { root: true });
                    commit(
                        'SET_ERROR_INFO',
                        '<br>' +
                        'Server responded with error = True <br> errorCode: ' +
                        res.data.errorCode, { root: true }
                    );
                }
                commit('SET_REPORT', res);
                commit('SET_LOADING', false);
                return res;
            })
            .catch((err) => {
                commit('SET_ERROR_BIT', true, { root: true });
                commit('SET_ERROR_INFO', err.stack, { root: true });
            });
    },

    getMarketReport({ commit, dispatch, state }, params) {
        let currentSession = localStorage.getItem(
            'vue-authenticate.vueauth_access_token'
        );
        commit('SET_LOADING', true);
        commit('SET_MARKET_REPORT', {});

        return service
            .getMarketReport({
                session_id: currentSession,
                report_id: params.report_id,
            })
            .then((res) => {
                if (res.hasOwnProperty('data') && res.data.error) {
                    commit('SET_ERROR_BIT', true, { root: true });
                    commit(
                        'SET_ERROR_INFO',
                        '<br>' +
                        'Server responded with error = True <br> errorCode: ' +
                        res.data.errorCode, { root: true }
                    );
                }
                commit('SET_MARKET_REPORT', res);
                commit('SET_LOADING', false);
                return res;
            })
            .catch((err) => {
                commit('SET_ERROR_BIT', true, { root: true });
                commit('SET_ERROR_INFO', err.stack, { root: true });
            });
    },

    getVestimateReport({ commit, dispatch, state }, params) {
        let currentSession = localStorage.getItem(
            'vue-authenticate.vueauth_access_token'
        );
        commit('SET_LOADING', true);
        commit('SET_VESTIMATE_REPORT', {});

        return service
            .getVestimateReport({
                session_id: currentSession,
                report_id: params.report_id,
            })
            .then((res) => {
                if (res.hasOwnProperty('data') && res.data.error) {
                    commit('SET_ERROR_BIT', true, { root: true });
                    commit(
                        'SET_ERROR_INFO',
                        '<br>' +
                        'Server responded with error = True <br> errorCode: ' +
                        res.data.errorCode, { root: true }
                    );
                }
                commit('SET_VESTIMATE_REPORT', res);
                commit('SET_LOADING', false);
                return res;
            })
            .catch((err) => {
                commit('SET_ERROR_BIT', true, { root: true });
                commit('SET_ERROR_INFO', err.stack, { root: true });
            });
    },

    getCompanyReport({ commit, dispatch, state }, params) {
        let currentSession = localStorage.getItem(
            'vue-authenticate.vueauth_access_token'
        );
        commit('SET_LOADING', true);
        commit('SET_COMPANY_REPORT', {});

        return service
            .getCompanyReport({
                session_id: currentSession,
                report_id: params.report_id,
            })
            .then((res) => {
                if (res.hasOwnProperty('data') && res.data.error) {
                    commit('SET_ERROR_BIT', true, { root: true });
                    commit(
                        'SET_ERROR_INFO',
                        '<br>' +
                        'Server responded with error = True <br> errorCode: ' +
                        res.data.errorCode, { root: true }
                    );
                }
                commit('SET_COMPANY_REPORT', res.data);
                commit('SET_LOADING', false);
                return res;
            })
            .catch((err) => {
                commit('SET_ERROR_BIT', true, { root: true });
                commit('SET_ERROR_INFO', err.stack, { root: true });
            });
    },

    saveReport({ commit, dispatch, state }, params) {
        let currentSession = localStorage.getItem(
            'vue-authenticate.vueauth_access_token'
        );

        return service
            .saveReport({
                session_id: currentSession,
                ...params,
            })
            .then((res) => {
                if (res.hasOwnProperty('data') && res.data.error) {
                    commit('SET_ERROR_BIT', true, { root: true });
                    commit(
                        'SET_ERROR_INFO',
                        '<br>' +
                        'Server responded with error = True <br> errorCode: ' +
                        res.data.errorCode, { root: true }
                    );
                }
            });
    },

    saveVestimateReport({ commit, dispatch, state }, params) {
        let currentSession = localStorage.getItem(
            'vue-authenticate.vueauth_access_token'
        );

        return service
            .saveReport({
                session_id: currentSession,
                ...params,
            })
            .then((res) => {
                if (res.hasOwnProperty('data') && res.data.error) {
                    commit('SET_ERROR_BIT', true, { root: true });
                    commit(
                        'SET_ERROR_INFO',
                        '<br>' +
                        'Server responded with error = True <br> errorCode: ' +
                        res.data.errorCode, { root: true }
                    );
                }
                return dispatch('getVestimateReport', {
                    report_id: params.report_id,
                })
                    .then(() => {
                        if (res.hasOwnProperty('data') && res.data.error) {
                            commit('SET_ERROR_BIT', true, { root: true });
                            commit(
                                'SET_ERROR_INFO',
                                '<br>' +
                                'Server responded with error = True <br> errorCode: ' +
                                res.data.errorCode, { root: true }
                            );
                        }
                        return res;
                    })
                    .catch((err) => {
                        commit('SET_ERROR_BIT', true, { root: true });
                        commit('SET_ERROR_INFO', err.stack, { root: true });
                    });
            });
    },
};

const getters = {
    home: (state) => {
        return state.home !== "" && state.home && state.home.indexOf(" ") === 0 ? state.home : "Search";
    },
    companyReport: (state) => state.company_report,
    market_report: (state) => state.market_report,
    vestimate_report: (state) => state.vestimate_report,
    financial_report: (state) => state.report,
    activeSection: (state) => state.activeSection,
    user_type: (state) => state.user_type,
    allow_retail: (state) => state.allow_retail,
    academic_ip: (state) => state.academic_ip,
    user_subscriptions: (state) => state.user_subscriptions,
    user_IBBA2021: (state) => state.user_IBBA2021,
    pdfLoading: (state) => state.pdfLoading,
    pdfLoading2: (state) => state.pdfLoading2,
    csvLoading2: (state) => state.csvLoading,
    user_subscriptionsData: (state) => state.user_subscriptions,
    cmnText: (state) => state.cmnText,
    totalActiveTeamMembers: (state) => state.totalActiveTeamMembers,
    totalTeamMembers: (state) => state.totalTeamMembers,
    user_id: (state) => state.user?.userID,
    pdfMustBeDownloaded: (state) => (state.user?.preferences?.defaultPDFDownload ?? '') !== "Open in new window",
    userAccess: (state) => state.userAccess,
};

const user = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

export default user;